"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    contactScrollContainer: { height: '45vh', paddingRight: 20 },
    contact: { borderBottomWidth: 1, borderColor: colors_1.default.BORDER_COLOR, padding: 10 },
});
exports.default = styles;
